module.exports = __webpack_public_path__ + "static/media/William Jennings Bryan - 1900.a52293aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/William Jennings Bryan - 1900.jpg
// module id = 572
// module chunks = 0